import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
	rus: (
		`
		<div style="text-align: justify;">

			<p class="mb-3">
				Сегодня я получил новое интересное задание: вывести самоуничтожающееся существо. 
				Раньше мы делали такие исследования в глобальном масштабе: самоуничтожающаяся планета, с получением в результате некоторых полезных веществ, 
				которые иначе получить было бы невыгодно или неудобно. 
				Однако несколько таких экспериментов закончились провалом: взрывом или распадом с выделением совсем не полезных, а даже весьма вредных веществ. 
				И руководство нашего института решило закрыть это направление, и заняться более многообещающей проблемой: 
				созданием постоянных планет с меняющимся населением, которое будет вырабатывать нужные нам вещества в нужных количествах в течение определённого времени, 
				а потом самоэлиминироваться, освобождая среду для новых вселенцев. 
				Гораздо более разумный и экономичный путь.
			</p>
			
			
			<p class="text-center bold mb-3">* * *</p>
	
		
			<p class="mb-3"> 
				После нескольких попыток получилось вертикальное органическое существо, 
				могущее самостоятельно размножаться и производить из окружающей среды некоторые полезные нам вещества, например мочевину, индол и скатол, 
				намного дешевле, чем мы бы синтезировали их сами. 
				После получения необходимого количества веществ включается запрограммированное поведение, 
				– и существа освобождают поверхность своей «планеты» для новой популяции, производящей новые необходимые нам продукты. 
				Безотходная технология. 
			</p>
	
			<p class="mb-3">
				За время своего существования популяция вырабатывает внутри себя какие-то отношения, понятия, 
				в том числе и относительно самих себя и своего места в космосе. 
				Разумеется, они считают себя венцом творения, но всё-таки ищут, кто же их сотворил. 
				Иногда я для развлечения подключаюсь к их сознанию и слушаю, как они меня называют: Аллах, Иегова, Саваоф… и много-много других слов. 
				Хорошо, что мы, дав им сознание, ограничили его стремлением исследовать и изменять только окружающий мир, а не самих себя. 
				Исследование собственного мозга, своих желаний и стремлений и их причин – для них табу, невозможно. 
				Иначе бы они стали самостоятельны, вышли бы из нашего контроля… и не выполняли бы тех действий, для которых были предназначены. 
				А зачем они тогда нужны?
			</p>
	
			<p class="text-center bold mb-3">* * *</p>
	
			
			<p class="mb-3">
				Я занимаюсь созданием вирусов. 
				Это очень многообещающая тема, раскрывающая огромные возможности в разных областях жизни. 
				Не только в генетике и медицине, как думают многие; мы, например, 
				в нашем отделе занимаемся созданием наноматериалов на основе вирусов для молекулярной электроники, 
				где вирусы выступают как носители или как шаблоны для создания новых материалов. 
				Наши искусственные вирусы, в отличие от естественных, легко уничтожить, просто разорвав их ДНК-цепочки, что мы научились делать уже давно. 
				Недалеко то время, когда мы сможем так же легко уничтожать естественные болезнетворные вирусы. 
				Это будет огромная победа человека над природой.
			</p>
	
			
			<p class="text-center bold mb-3">* * *</p>
	
			
			<p class="mb-3">
				Нобелевская премия по медицине за 2… год была вручена ХХХ УУУ из ZZZ за открытие способа инактивации болезнетворных вирусов в природе. 
				За последующие десятки лет фантастически выросло благосостояние человечества, избавленного от болезней: 
				не только своих, но и поражающих животных и растения, необходимые человеку. 
				Наконец-то жизнь человека перестала зависеть от случайных факторов природы и стала принадлежать только ему самому! 
			</p>
	
			
			<p class="text-center bold mb-3">* * *</p>
	
			
			<p>
				В связи с завершением проекта по созданию самоуничтожающегося существа, продуцирующего вещества А, Б и В, по причине нахождения другого, более экономичного способа получения этих веществ, 
			</p>
			<p class="mb-3">
				ПОСТАНОВЛЯЕМ:
			</p>
			<p>
				А) ввести в действие программу самоуничтожения этих существ на использованном полигоне ₡₩‡
			</p>
			<p>
				Б) полностью зачистить и продезинфицировать полигон ₡₩‡ 
			</p>
			<p>
				В) об исполнении доложить
			</p>
			
			<table class="m-lg-3" style="width: 100%;">
				<tr>
					<td>Подпись</td>
					<td>Печать</td>
				</tr>
			</table>
	
	
			<p class="text-center bold mb-3">* * *</p>
	
			<p class="mb-3">
				Из отчёта машинного устройства NPG:
			</p>
			<p class="mb-3">
				… В результате проведённых мероприятий, устранены органические существа, проводившие эксперименты по созданию и применению других органических существ, 
				заполнявших территории, естественно предназначенные для развития неорганической формы существования как высшей формы существования материи и энергии. 
			</p>
			<p class="mb-3">
				Таким образом, жизненное пространство для нашей цивилизации зачищено и ждёт нас. 
			</p>
			<p class="mb-3">
				СЛАВА НАМ!!
			</p>
		</div>
		
		`
	)
}

const itemName = {
	rus: `Ступени познания`
}

const itemDate = {
	rus: `23 октября 2023`
}

const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemDate: itemDate.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}

export default item;